import DOMPurify from "dompurify";

/**
 * Single-policy HTML sanitizer for everywhere we use `dangerouslySetInnerHTML`.
 *
 * Inputs flagged for sanitization:
 *  - Email bodies (activity-log + email-logs) — admin-authored AND third-party-rendered
 *    (SendGrid templates, customer reply quotes). Has historically contained <script> from
 *    upstream sources.
 *  - Whiteboard messages — typed by other admins, but stored XSS could persist across users.
 *  - Email-template previews and report-footer previews — admin-authored, but a compromised
 *    admin account is exactly the lateral-escalation vector this guards against.
 *
 * DOMPurify defaults are sane (strips <script>, on* handlers, javascript: URLs, etc.) so we
 * don't override unless a specific surface needs different rules.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    // Allow `target` on anchors so existing "open L&F form" / "view in inbox" links keep
    // their target=_blank behavior. DOMPurify auto-adds rel="noopener noreferrer" to those.
    ADD_ATTR: ["target"],
  });
}
